/* LP-01.3 Trident landing page: variant and strap picker, add to cart, sticky CTA, count-up, scroll reveals. */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var setAll = function (sel, txt) { $$(sel).forEach(function (e) { e.textContent = txt; }); };

  function initOffer() {
    var root = document.querySelector('[data-lp013-offer]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var gallery = [];
    try { gallery = JSON.parse(document.querySelector('[data-lp013-gallery]').textContent); } catch (e) {}
    var main = root.querySelector('[data-lp013-main]');
    var thumbs = root.querySelector('[data-lp013-thumbs]');
    var buy = root.querySelector('[data-lp013-buy]');
    var cards = $$('.lp013-var', root), straps = $$('.lp013-strap', root);
    var freeStrap = root.dataset.freeStrap === 'true';
    var cur = null, curStrap = null;

    function link() {
      if (!cur) return;
      buy.href = '/cart/' + cur.dataset.id + ':1' + (freeStrap && curStrap ? ',' + curStrap.dataset.id + ':1' : '');
    }
    function buildThumbs(card) {
      thumbs.innerHTML = '';
      [{ img: card.dataset.img, alt: card.dataset.alt }].concat(gallery).slice(0, 5).forEach(function (t, i) {
        var b = document.createElement('button'), im = document.createElement('img');
        b.type = 'button'; b.className = 'lp013-thumb'; b.setAttribute('aria-pressed', i === 0);
        im.src = t.img; im.alt = t.alt; b.appendChild(im);
        b.addEventListener('click', function () {
          main.src = t.img; main.alt = t.alt;
          $$('.lp013-thumb', thumbs).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        });
        thumbs.appendChild(b);
      });
    }
    function select(card) {
      cur = card;
      cards.forEach(function (c) { c.setAttribute('aria-pressed', c === card); });
      main.src = card.dataset.img; main.alt = card.dataset.alt;
      buildThumbs(card);
      setAll('[data-lp013-now]', card.dataset.now);
      setAll('[data-lp013-was]', card.dataset.was);
      setAll('[data-lp013-btn]', card.dataset.now);
      link();
    }
    function selectStrap(b) {
      curStrap = b;
      straps.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      setAll('[data-lp013-strap-was]', b.dataset.was);
      link();
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    straps.forEach(function (b) { b.addEventListener('click', function () { selectStrap(b); }); });
    var firstStrap = straps.filter(function (b) { return !b.disabled; })[0];
    if (firstStrap) selectStrap(firstStrap);
    var first = cards.filter(function (c) { return !c.disabled; })[0];
    if (first) select(first);

    buy.addEventListener('click', function (e) {
      if (!cur || !window.fetch) return;
      e.preventDefault();
      var href = buy.href, items = [{ id: parseInt(cur.dataset.id, 10), quantity: 1 }];
      if (freeStrap && curStrap) items.push({ id: parseInt(curStrap.dataset.id, 10), quantity: 1 });
      buy.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        buy.removeAttribute('aria-busy');
        try {
          if (window.upcartOpenCart) window.upcartOpenCart();
          else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
        } catch (err) {}
      }).catch(function () { window.location.href = href; });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-lp013-sticky]');
    var hero = document.getElementById('top'), offer = document.getElementById('offer');
    if (!sticky || !hero || !offer || !('IntersectionObserver' in window)) return;
    var heroVisible = true, offerVisible = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === hero) heroVisible = e.isIntersecting;
        if (e.target === offer) offerVisible = e.isIntersecting;
      });
      sticky.classList.toggle('lp013-on', !heroVisible && !offerVisible);
    }, { threshold: 0.05 });
    io.observe(hero); io.observe(offer);
  }

  function countUp(stat) {
    var b = stat.querySelector('b'), small = b.querySelector('small');
    var suffix = small ? small.outerHTML : '', raw = b.firstChild.textContent.trim();
    var target = parseFloat(raw), dec = (raw.split('.')[1] || '').length;
    if (isNaN(target)) return;
    var t0 = performance.now(), dur = 1100;
    (function tick(now) {
      var k = Math.min(1, (now - t0) / dur), v = target * (1 - Math.pow(1 - k, 3));
      b.innerHTML = v.toFixed(dec) + suffix;
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }

  function initReveal() {
    if (window.Shopify && Shopify.designMode) return; /* never hide content in the theme editor */
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var groups = ['.lp013-sec-head', '.lp013-timeline li', '.lp013-arch', '.lp013-tile', '.lp013-strip .lp013-cell', '.lp013-split .lp013-txt', '.lp013-fail', '.lp013-cmp', '.lp013-stat', '.lp013-gallery', '.lp013-offer .lp013-card', '.lp013-rev', '.lp013-gcell', '.lp013-band .lp013-q', '.lp013-band .lp013-who', '.lp013-faq details', '.lp013-final .lp013-wrap > *', '.lp013-std-img'];
    var seen = [];
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('lp013-in');
        io.unobserve(e.target);
        if (e.target.classList.contains('lp013-stat')) countUp(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    groups.forEach(function (sel) {
      var i = 0;
      $$(sel).forEach(function (el) {
        if (seen.indexOf(el) > -1) return;
        seen.push(el);
        el.classList.add(sel === '.lp013-gallery' || sel === '.lp013-std-img' ? 'lp013-reveal-scale' : 'lp013-reveal');
        el.style.setProperty('--d', Math.min(i * 80, 480) + 'ms');
        i++;
        io.observe(el);
      });
    });
  }

  function init() { initOffer(); initSticky(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initOffer);
})();
